import { render, staticRenderFns } from "./RegistroMediaFiliacion.vue?vue&type=template&id=1cf05e7f"
import script from "./RegistroMediaFiliacion.vue?vue&type=script&lang=js"
export * from "./RegistroMediaFiliacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports